import React, { useEffect, useState } from 'react';
import { useForm,Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import * as EmailValidator from 'email-validator';
import AuthLayout from '../Layouts/Authlayout';
import {
  PLACEHOLDER_EMAIL,
  ERR_EMAIL,
  ERR_EMAIL_INVALID,
  ERR_INVALID_CREDENTIALS,
  FORGOT_PASSWORD_TITLE,
  LABEL_HEADER_NOTE,
  BTN_SEND_LINK,
  LABEL_RETURN_LOGIN
} from '../../constants/constant';
import { InputAdornment, TextField } from '@mui/material';
import '../Styles/login.css';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import type {ForogotPasswordInputs, ForogotPasswordResponse} from '../types/types';
import {
    forgotPassword
  } from 'src/services/forgotPasswordService';

const validationSchema = Yup.object().shape({
    email: Yup.string()
    .required(ERR_EMAIL)
    .email(ERR_EMAIL_INVALID)
    .test(
      'is-valid-email',
      ERR_EMAIL_INVALID,
      (value) => value === '' || EmailValidator.validate(value),
    )
});

export default function ForgotPassword(): JSX.Element {
  
  const [message, setMessage] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<ForogotPasswordInputs>({
    resolver: yupResolver(validationSchema),
    mode: 'onSubmit',
  });
  const navigate = useNavigate();
  const onSubmit = async (data: ForogotPasswordInputs): Promise<void> => {
 
    setLoading(true); 
     const params={
        email: data.email
     }
      forgotPassword(JSON.stringify(params))
        .then((res: ForogotPasswordResponse) => {
            console.log(res);
            if (res.status === 200 && res.data.result == 1) {              
                navigate(`/forgot-password-success?email=${encodeURIComponent(data.email)}`);
              } else {
                setMessage(res.data.messages);
                setLoading(false);
              }
        })
        .catch((error) => {
            setError(error);
            console.log('Error: ', error)})
        .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (error !== '' && error !== null) {
      setMessage(ERR_INVALID_CREDENTIALS);
    }
  }, [error]);

  return (
    <AuthLayout>
      <h1 className="text-center text-[18px] font-bold text-muted mb-[15px]">
        {FORGOT_PASSWORD_TITLE}
      </h1>
      <p className="text-subtitle text-center text-[14px] mb-[35px]">
        {LABEL_HEADER_NOTE}
      </p>
      <div className="login-content w-full">
        {message !== "" && (
          <div className="w-full mb-[15px] border border-ED4B52 bg-errorbg rounded-lg text-center pt-[10px] pb-[13px] text-14 font-semibold text-primary">
            <span>{message}</span>
          </div>
        )}
         <form
          onSubmit={(e) => {
            e.preventDefault();
            void handleSubmit(onSubmit)(e);
          }}
        >
          <div className="mb-[30px]">
          <Controller
              name="email"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Email address"
                  autoComplete="off"
                  placeholder={PLACEHOLDER_EMAIL}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img
                          src="/assets/images/input-email.svg"
                          alt="email"
                          width={22}
                          height={20}
                        />
                      </InputAdornment>
                    ),
                  }}
                  error={Boolean(errors.email)}
                  helperText={
                    errors.email ? (
                      <span className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeMedium MuiFormHelperText-contained css-1d3jg1r pl-3" style={{ display: 'flex', alignItems: 'center'}}>
                        <ReportProblemOutlinedIcon style={{ color: '#ed4b52', fontSize: '12px', marginRight: '4px' }} />
                        {errors.email.message}
                      </span>
                    ) : null
                  }
                />
              )}
            />
            
          </div>
          <button
            type="submit"
            disabled={loading}
            className="btn btn-block bg-gradient-to-b border-0 from-red to-[#D6242C] h-[45px] text-14 capitalize focus-visible:outline-none rounded-50 font-semibold hover:from-[#D6242C] hover:to-[#ED4B52] text-white disabled:btn-primary disabled:opacity-100 disabled:text-white"
          >
            {!loading ? (
              `${BTN_SEND_LINK}`
            ) : (
              <span className="loading loading-spinner loading-xs text-white"></span>
            )}
          </button>
        </form>
        <div className="text-center  mt-4">
          <a
            href="/"
            className="text-center text-muted hover:text-primary underline text-14 inline-block"
          >
            {LABEL_RETURN_LOGIN}
          </a>
        </div>
      </div>
    </AuthLayout>
  );
}
